import { render, staticRenderFns } from "./searchModalWindow.vue?vue&type=template&id=1a9bfb54"
import script from "./searchModalWindow.ts?vue&type=script&lang=js&external"
export * from "./searchModalWindow.ts?vue&type=script&lang=js&external"
import style0 from "./searchModalWindow.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports